import React, { SVGProps } from 'react'

const SvgAutoReview = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={27}
    viewBox="0 0 28 27"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path d="M20 6L9 17L4 12" stroke="#4F3FDD" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <g clipPath="url(#clip0_2440_182)">
    <path d="M19.5007 14.4502L16.2538 19.173C16.0583 19.4573 15.9606 19.5994 15.9665 19.7176C15.9716 19.8205 16.0218 19.916 16.1037 19.9785C16.1977 20.0502 16.3702 20.0502 16.7152 20.0502H19.5007V23.5502L22.7476 18.8275C22.943 18.5432 23.0407 18.401 23.0349 18.2829C23.0298 18.18 22.9796 18.0845 22.8977 18.022C22.8036 17.9502 22.6311 17.9502 22.2861 17.9502H19.5007V14.4502Z" fill="#4F3FDD"/>
    <path d="M19.5007 26.0002C23.3667 26.0002 26.5007 22.8662 26.5007 19.0002C26.5007 15.1343 23.3667 12.0002 19.5007 12.0002C15.6347 12.0002 12.5007 15.1343 12.5007 19.0002C12.5007 22.8662 15.6347 26.0002 19.5007 26.0002Z" fill="#4F3FDD"/>
    <path d="M19.5007 14.4502L16.2538 19.173C16.0583 19.4573 15.9606 19.5994 15.9665 19.7176C15.9716 19.8205 16.0218 19.916 16.1037 19.9785C16.1977 20.0502 16.3702 20.0502 16.7152 20.0502H19.5007V23.5502L22.7476 18.8275C22.943 18.5432 23.0407 18.401 23.0349 18.2829C23.0298 18.18 22.9796 18.0845 22.8977 18.022C22.8036 17.9502 22.6311 17.9502 22.2861 17.9502H19.5007V14.4502Z" stroke="white" strokeWidth="1.12" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M19.5007 26.0002C23.3667 26.0002 26.5007 22.8662 26.5007 19.0002C26.5007 15.1343 23.3667 12.0002 19.5007 12.0002C15.6347 12.0002 12.5007 15.1343 12.5007 19.0002C12.5007 22.8662 15.6347 26.0002 19.5007 26.0002Z" stroke="white" strokeWidth="1.12" strokeLinecap="round" strokeLinejoin="round"/>
    <rect x="19.4994" y="18.9998" width="1.33333" height="2.66667" fill="white"/>
    <rect x="16.8327" y="17.6665" width="5.33333" height="2.66667" fill="white"/>
    <rect x="18.166" y="16.333" width="1.33333" height="2.66667" fill="white"/>
    </g>
    <defs>
    <clipPath id="clip0_2440_182">
    <rect width="16" height="16" fill="white" transform="translate(11.5 11)"/>
    </clipPath>
    </defs>
  </svg>
)
export default SvgAutoReview
